module.exports = __webpack_public_path__ + "static/checkbox-4-578873389f880bb53d84949e2e9f1c70.png";